export const pageTitle = (title) => {
  return ( document.title = "ERROR STUDIO | Quality Matters - " + title);
}